// Module Name
import { v1 as uuidv1 } from 'uuid';
import isEqual from 'lodash/isEqual';
import { ModalHocProps } from '../../../components/modals/createModalHOC';

export const name = 'modals';

/////// MODALTYPE ///////
export enum ModalType {
    CONFIRMATION = 'CONFIRMATION',
    DELETE = 'DELETE',
    EDITION = 'EDITION',
    FILTER = 'FILTER',
    FORM = 'FORM',
    RECURRENCE = 'RECURRENCE',
    ADDRESS = 'ADDRESS',
    SELF_SERVICE = 'SELF_SERVICE',
    MARCEL = 'MARCEL',
    WICKED = 'WICKED',
    ONBOARDING = 'ONBOARDING',
    ONBOARD_PAYMENT = 'ONBOARD_PAYMENT',
    VOUCHER_FORM = 'VOUCHER_FORM',
    PAYMENT_CLEARANCE = 'PAYMENT_CLEARANCE',
}

// ActionTypes
export const types = {
    OPEN_MODAL: `${name}/OPEN_MODAL`,
    CLOSE_MODAL: `${name}/CLOSE_MODAL`,
    DISPLAY_MODAL: `${name}/DISPLAY_MODAL`,
};

export interface ModalInfos {
    modalType: ModalType;
    modalProps: any;
    id: string;
}

// InitialState
export const initialState = {
    isOpen: false,
    modals: Array<ModalInfos>(),
};

export type ModalState = typeof initialState;

function isModalExists(state: ModalState, actionProps: any): boolean {
    return !!state.modals.find((modal) => isEqual(modal.modalProps, actionProps));
}

// Reducer
export default (state = initialState, action: any = {}): any => {
    switch (action.type) {
        case types.OPEN_MODAL: {
            const foundModal = isModalExists(state, action.payload.props);
            let stateModals = {};
            if (!foundModal) {
                stateModals = {
                    modals: [
                        ...state.modals,
                        {
                            id: action.payload.id,
                            modalType: action.payload.modalType,
                            modalProps: action.payload.props,
                        },
                    ],
                };
            }
            return {
                ...state,
                ...stateModals,
            };
        }
        case types.DISPLAY_MODAL:
            return {
                ...state,
                isOpen: true,
            };
        case types.CLOSE_MODAL: {
            const modals = state.modals.filter((modal) => modal.id !== action.payload.id);
            return {
                ...state,
                modals,
                isOpen: false,
            };
        }
        default:
            return state;
    }
};

export interface ActionOpenModalProps extends Omit<ModalHocProps, 'isOpen' | 'onRequestClose'> {
    [key: string]: any;
}
export type ActionOpenModal = (modalType: ModalType, props: ActionOpenModalProps) => any;
export type ActionCloseModal = (id: string) => any;

// ActionCreators
export const actions = {
    openModal: (modalType: ModalType, props: ActionOpenModalProps, id?: string): any => ({
        type: types.OPEN_MODAL,
        payload: { modalType, props, id: id || uuidv1() },
    }),
    closeModal: (id: string): any => ({ type: types.CLOSE_MODAL, payload: { id } }),
    displayModal: (): any => ({ type: types.DISPLAY_MODAL }),
};

// Selectors
const localState = (state: any): ModalState => state[name] || initialState;
export const selectors = {
    isOpen: (state: any): boolean => localState(state).isOpen,
    modalsLength: (state: any): number => localState(state).modals.length,
    modals: (state: any): ModalInfos[] => localState(state).modals,
    modal: (state: any): ModalInfos => localState(state).modals[0],
};
